import type { PrefetchType, DashboardConfigType } from '../../types.tsx';
import { getPrefetchDict } from './get-prefetch-dict.tsx';

export type DashboardConfigGadgets = Pick<DashboardConfigType, 'gadgets'>;

export const getPrefetches = ({ gadgets }: DashboardConfigGadgets): PrefetchType[] => {
	const lookup = getPrefetchDict();

	return gadgets.flatMap((gadget) => {
		const identifier = gadget.amdModule;
		const prefechProp = identifier != null ? lookup[identifier] : undefined;
		if (!prefechProp || !prefechProp.enabled) {
			return [];
		}
		const { func, priority, isSyncLoadingSupported } = prefechProp;
		return func(gadget).map((url) => ({
			url,
			priority,
			isSyncLoadingSupported,
		}));
	});
};
